import variables from "@/config/variables";

export const URLS = {
  base_url: variables.NEXT_PUBLIC_API_BASE_URL,
  redirect_url: process.env.NEXT_PUBLIC_REDIRECT_URL,
  get_login_url_endpoint: "/azure-login/getLoginUrl",
  get_sa_login_url_endpoint: "/azure-admin-login/getAdminLoginUrl",
  get_seller_token_url_endpoint: "/azure-login/getToken",
  get_sa_token_url_endpoint: "/azure-admin-login/getAdminToken",
};
export const RESPONSE_STATUSES = {
  CREATED: 201,
  SUCCESS: 200,
  NOT_FOUND: 404,
  FATAL: 500,
  ERROR: 400,
};
export const RESPONSE_DESCRIPTIONS = {
  PRODUCT_NOT_A_PARCEL: "Product not a parcel",
};
export const API_ENDPOINTS = {
  ADMIN: {
    SETTINGS: {
      EBAY: {
        ITEM_CONDITION: {
          CREATE: "/itemCondition/createItemCondition",
          UPDATE: "/itemCondition/updateItemCondition",
          GET_ALL: "/itemCondition/all",
        },
        DISCOUNT_ALLOCATION: {
          GET_ALL: "/discountAllocation/all",
          CREATE: "/discountAllocation/createDiscountAllocation",
        },
        DISCOUNT_SETTINGS: {
          CREATE: "/discount/createOrUpdate",
          GET_ALL: "/discount/all",
          GET_BY_ID: "/discount/getById",
        },
      },
      SHIPPING: {
        CREATE: "/shipping/createShipping",
        GET_ALL: "/shipping/all",
      },
    },
  },
  LISTING: {
    EASY_LISTER: {
      GET_DISCOUNT_PROFILE_BY_PRODUCT_ID:
        "/discountAllocation/getByGlobalProductId",
      GET_PRODUCT_BY_ID: "/products/getProductById",
      UPLOAD_ON_EBAY: "/products/addEbayItem",
      UPSERT_MARKETPLACE_LISTING: "/item-listing/upsertMarketplaceListing",
      REPORT_ARTICLE: "/outlet/sendMissingProductReportEmail",
    },
    GET_ALL_PRODUCTS_LISTED_ON_EBAY: "/item-listing/getAllEbayListedItem",
    GET_ALL_EBAY_LISTED_ITEMS_STATS: "/item-listing/stats",
    GET_LISTED_ITEM_REQUEST_PAYLOAD_BY_EBAY_ITEM_ID:
      "/item-listing/getListedItemRequestPayloadByEbayItemId",
    REMOVE_EBAY_ITEM: "/item-listing/removeEbayItem",
    REMOVE_MIRAKL_OFFER_LISTING: "/item-listing/removeMiraklOfferListing",
  },
  OUTLET: {
    CREATE: "/outlet/create",
    UPDATE: "/outlet/update",
    DELETE: "/outlet",
    GET_ALL: "/outlet/all",
    REAUTHENTICATE: "/outlet/reauthenticateEbaySeller",
    COMPLETE_ONBOARDING: "/onboarding-controller/completeOnboardingProcess",
    UPLOAD_FILE: "/outlet/uploadFileForOutlet",
    USER_CONSENT: "/ebay/user-access-token/authorize",
    USER_ACCESS_TOKEN: "/ebay/user-access-token/token",
  },
  EBAY_UPLOAD: {
    BULK_UPLOAD: "/uploadBulkFile/upload",
    UPDATE_PRODUCT_BY_PROCESS_ID: "uploadBulkFile/updateProductById",
    GET_PRODUCTS_BY_PROCESS_ID: "/uploadBulkFile/getProductsByProcessId",
    GET_ALL_PROCESSES: "/uploadBulkFile/processes/all",
    DELETE_PRODUCTS_BY_IDS: "/uploadBulkFile/deleteGlobalProductId",
    DELETE_PRIOCESS_BY_ID: "/uploadBulkFile/deleteAllGlobalIdsByProcessId",
    GET_DISCOUNT_PROFILES_BY_ITEM_CONDITION:
      "/discountAllocation/getByConditionAndMarketPlace",
  },
  FILE_UPLOAD: "/files/upload",
  EBAY_ORDERS: {
    GET_EBAY_ORDERS: "/ebay-order/getEbayOrders",
    GET_BY_ORDER_ID: "/ebay-order/getByOrderId",
    GET_STATS: "/ebay-order/getEbayOrderStats",
    UPDATE_BY_ORDER_ID: "/ebay-order/updateEbayOrderById",
    CANCEL_SELLER_ORDER: "/ebay-order/cancelSellerOrder",
    PROCESS_ORDER_CANCELLATION: "/ebay-order/processEbayOrderCancellation",
    DECLINE_BUYER_CANCEL_REQUEST:
      "/ebay-order/declineEbayOrderCancelCancellation",
    ADD_SHIPMENT_TRACKING: "/ebay-order/addShipmentTracking",
    MARK_COMPLETED: "/ebay-order/markCompleted",
    CREATE_SHIPPING_LABEL: "/ebay-order/createShipmentLabelForDHL",
    UPDATE_DELIVERY_ADDRESS: "/ebay-order/updateEbayOrderDeliveryAddress",
  },
  EBAY_RETURNS: {
    GET_ALL_EBAY_RETURNS: "/ebay-return/getAllEbayReturns",
    GET_EBAY_RETURNS_STATS: "/ebay-return/getEbayReturnStats",
    GET_EBAY_RETURN_BY_ID: "/ebay-return/getEbayReturnById",
    UPDATE_EBAY_RETURN: "/ebay-return/updateEbayReturns",
    REFUND_RETURN: "/ebay-return/refundReturn",
  },
  AUDIT_LOG: {
    GET_ALL: "/audit-log/all",
    GET_BY_ID: "/audit-log/getById",
    EBAY_ORDER_GET_ALL: "/ebay-order-audit-log/all",
    EBAY_ORDER_GET_BY_ID: "/ebay-order-audit-log/getById",
    EBAY_RETURN_GET_ALL: "/ebay-return-audit-log/all",
    EBAY_RETURN_GET_BY_ID: "/ebay-return-audit-log/getById",
  },
  MESSAGES: {
    GET_ALL: "/ebay-my-message/getAllEbayMyMessages",
  },
  BANNER: {
    CREATE: "/banner/createBanner",
    UPDATE: "/banner/updateBanner",
    GET: "/banner/getBanner",
  },
  DASHBOARD: {
    USER_DETAIL: {
      GET_BY_ID: "/userDetail/getUserDetailById",
    },

    GET_DASHBOARD_STATS: "/dashboard/getDashboardStats",
    GET_DASHBOARD_REPORT: "/report/getDashboardReport",
  },
  RANKINGS: {
    GET_RANKING_DATA: "/report/ranking",
  },
};
